import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import React, { useState } from 'react';
import {
  FDPrimaryActionButton,
  FDSecondaryActionIconButton, FDStack,
  FDTable, FDTableBody, FDTableCell,
  FDTableHead, FDTableRow,
  FDTitleText,
} from '@facet-wealth/design';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import {
  USDCurrencyFullFormatterNoFraction,
} from 'Helpers/Formats';
import { monthYear } from 'Consts/DateFormats';
import moment from 'moment';
import metaOverrideSet from '../../metaOverrideSet';

const FacetPlanCustomStrategySetupCatchUpAssumption = ({ label, attrName, resourceLayout }) => {
  const { resource, handleChange } = useMetaLayoutContext();

  const [assumptionResource, setAssumptionResource] = useState();

  const onAddNewEntry = () => {
    setAssumptionResource(resource.attr(attrName).create());
  };

  const handleDiscardAssumption = () => {
    setAssumptionResource(undefined);
  };

  const handleAddAssumption = (updatedResource) => {
    // put resource on to collection of additional closing costs
    resource.attr(attrName).resources().pushItem(null, updatedResource);
    handleDiscardAssumption();
    handleChange(attrName, resource.attr(attrName)); // this sets the value and triggers a re-render so the new item appears
  };

  const handleDeleteAssumption = (index) => {
    resource.attr(attrName).resources().removeItemByIndex(index);
    handleChange(attrName, resource.attr(attrName)); // this sets the value and triggers a re-render so the deleted items disappear
  };

  const contributionLimitCollection = resource.attr(attrName);
  return (
    <FDStack direction={'column'} spacing={2}>
      <FDTitleText value={label} />
      <FDStack>
        <FDPrimaryActionButton
          icon="add"
          iconPosition="start"
          label="Add New Entry"
          onClick={() => onAddNewEntry()}
          size="sm"
          disabled={assumptionResource !== undefined}
        />
      </FDStack>
      {assumptionResource && (
        <MetaResourceRenderer
          resource={assumptionResource}
          layout={resourceLayout}
          metaOverrideSet={metaOverrideSet}
          LayoutProps={{
            onAdd: handleAddAssumption,
            onDiscard: handleDiscardAssumption,
          }}
        />
      )}
      {contributionLimitCollection.resources().list().length > 0 && (
        <FDTable>
          <FDTableHead>
            <FDTableCell>Start date</FDTableCell>
            <FDTableCell>End date</FDTableCell>
            <FDTableCell>Contribution limit</FDTableCell>
            <FDTableCell>Income limit</FDTableCell>
            <FDTableCell />
          </FDTableHead>
          <FDTableBody>
            {contributionLimitCollection.resources().list().map((entry, i) => {
              return (
                <FDTableRow
                  key={entry.id()}
                >
                  <FDTableCell>{moment(entry.attr('startDate')).utc().format(monthYear)}</FDTableCell>
                  <FDTableCell>{entry.attr('endDate') ? moment(entry.attr('endDate')).utc().format(monthYear) : 'None'}</FDTableCell>
                  <FDTableCell>{USDCurrencyFullFormatterNoFraction.format(entry.attr('value'))}</FDTableCell>
                  <FDTableCell>{entry.attr('incomeLimit') ? USDCurrencyFullFormatterNoFraction.format(entry.attr('incomeLimit')) : 'None'}</FDTableCell>
                  <FDTableCell>
                    <FDSecondaryActionIconButton
                      icon="close"
                      appearance={'text'}
                      onClick={() => handleDeleteAssumption(i)}
                      size="sm"
                    />
                  </FDTableCell>
                </FDTableRow>
              );
            })}
          </FDTableBody>
        </FDTable>
      )}

    </FDStack>
  );
};

FacetPlanCustomStrategySetupCatchUpAssumption.propTypes = {
  label: PropTypes.string.isRequired,
  attrName: PropTypes.string.isRequired,
  resourceLayout: PropTypes.object.isRequired,
};

export default FacetPlanCustomStrategySetupCatchUpAssumption;
